<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card>
      <v-app-bar flat color="red-darken-2">
        <v-app-bar-title>{{
          $t("part_requests.return.label")
        }}</v-app-bar-title>
      </v-app-bar>
      <v-card-text>
        <v-row column>
          <span v-if="selectedOfferIndex > -1">
            {{ request.assignedInstitutions[selectedOfferIndex].offer.notes }}
          </span>
          <v-text-field
            v-model="notes"
            :label="$t('part_requests.return.notes')"
            color="red"
          />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" variant="outlined" @click="close">
          {{ $t("part_requests.return.close") }}
        </v-btn>
        <v-spacer />
        <v-btn color="red" variant="outlined" :loading="loadingRefuse" @click="refuse">
          {{ $t("part_requests.return.refuse") }}
        </v-btn>
        <v-btn
          color="green"
          outlined
          :loading="loadingConfirm"
          @click="confirm"
        >
          {{ $t("part_requests.return.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import putRequest from "../../api/putRequest";

export default {
  data: () => ({
    dialog: false,
    loadingRefuse: false,
    loadingConfirm: false,
    notes: null,
    request: null,
  }),
  computed: {
    selectedOfferIndex() {
      if (!this.request) return -1;
      return this.request.assignedInstitutions.findIndex(
        (i) => i.offer.wantToReturn === true,
      );
    },
  },
  methods: {
    open(request) {
      this.dialog = true;
      this.request = request;
    },
    close() {
      this.request = null;
      this.dialog = false;
    },
    confirm() {
      this.loadingConfirm = true;
      putRequest("/part-request/confirm-return", `id=${this.request._id}`, {
        notes: this.notes,
      })
        .then(() => {
          this.$emit("confirmed");
        })
        .catch(() => {})
        .finally(() => {
          this.loadingConfirm = false;
          this.close();
        });
    },
    refuse() {
      this.loadingRefuse = true;
      putRequest("/part-request/refuse-return", `id=${this.request._id}`, {
        notes: this.notes,
      })
        .then(() => {
          this.$emit("refused");
        })
        .catch(() => {})
        .finally(() => {
          this.loadingRefuse = false;
          this.close();
        });
    },
  },
};
</script>
